document.addEventListener("DOMContentLoaded", function () {
  //
  //
  const totalElement = document.querySelector("[data-wholesale-total]");
  const addToCart = document.querySelector("[data-wholesale-add-to-cart]");
  const stickyTab = document.querySelector(".wholesale-sticky-tab");

  //
  //
  //
  let runningTotal = 0;
  // get the items from local storage
  let items = JSON.parse(localStorage.getItem("wholesale-items")) || [];
  updateTotal();
  populateQuantities();
  setEventListeners();
  adjustStickyTab();

  // add event listener for the collection:updated event for when facets update the filters
  document.addEventListener("collection:updated", function () {
    populateQuantities();
    setEventListeners();
  });

  // add event listener for the cart-updated event for when item qantities are updated in the cart
  document.addEventListener("cart-updated", function () {
    populateQuantities();
  });
  //
  //
  // clear button
  const clearButton = document.querySelector("[data-wholesale-clear]");
  clearButton?.addEventListener("click", function () {
    items = [];
    localStorage.removeItem("wholesale-items");
    updateTotal();
    populateQuantities();
    stickyTab.classList.remove("active");
  });
  //
  //
  //
  // if items is not empty, update the dom to show the items
  async function populateQuantities() {
    if (items.length > 0) {
      items.forEach((item) => {
        const input = document.querySelector(
          `[data-wholesale-variant="${item.id}"]`
        );

        if (input) {
          input.value = item.quantity;
        }
        // if qty is not 0, remove the disabled class to the qty_minus button
        if (item.quantity !== 0) {
          input.previousElementSibling.classList.remove("disabled");
        }
        // if qty is within 5 of max, add the disabled class to the qty_plus button
        if (item.quantity + 5 >= Number(input.max)) {
          input.nextElementSibling.classList.add("disabled");
        }
      });
    } else {
      // remove the items from the dom
      document.querySelectorAll("[data-wholesale-variant]").forEach((input) => {
        input.value = 0;
      });
    }

    // get current cart items
    await fetch(window.Shopify.routes.root + "cart.js")
      .then((res) => res.json())
      .then((data) => {
        // loop over cart items
        // - update the quantities available to add based on inventory - current cart items
        data.items.forEach((cartItem) => {
          const input = document.querySelector(
            `[data-wholesale-variant="${cartItem.variant_id}"]`
          );

          input?.setAttribute(
            "max",
            input.dataset.wholesaleInventory - cartItem.quantity
          );

          // insert the cart item quantity with message below qty select area
          const cartQuantityMessageElement = document.querySelector(
            `[data-cart-quantity-variant="${cartItem.variant_id}"]`
          );

          if (cartQuantityMessageElement) {
            cartQuantityMessageElement.textContent = `In cart: ${cartItem.quantity} of ${input.dataset.wholesaleInventory}`;
          }

          // if the quantity available is less than 5, add the disabled class to the qty_plus button
          if (
            input?.dataset.wholesaleInventory -
              cartItem.quantity -
              input?.value <
            5
          ) {
            input.nextElementSibling.classList.add("disabled");
          }

          // if the qty is 0, add the disabled class to the qty_minus button
          if (input?.value == 0) {
            input.previousElementSibling.classList.add("disabled");
          }
        });
      });
  }

  //
  //
  function setEventListeners() {
    // remove the event listeners from the old products
    document
      .querySelectorAll("[data-wholesale-qty-adjust]")
      .forEach((button) => {
        button.removeEventListener("click", adjustQuantity);
      });
    // get all the adjust buttons
    const newQtyAdjustbuttons = document.querySelectorAll(
      "[data-wholesale-qty-adjust]"
    );
    // add event listeners to the new buttons
    newQtyAdjustbuttons.forEach((button) => {
      button.addEventListener("click", adjustQuantity);
    });
  }

  //
  //
  // add event listener for the infinite scroll products added event
  document.addEventListener("infiniteScroll:productsAdded", function (event) {
    populateQuantities();
    setEventListeners();
  });

  //
  //
  function adjustQuantity(event) {
    //clear error message if it exists
    document.querySelector("[data-wholesale-error]").textContent = "";
    //
    const button = event.currentTarget;
    const qtyAdjust = button.dataset.wholesaleQtyAdjust;
    const input = button.closest(".product-quantity").querySelector("input");
    const variantId = input.dataset.wholesaleVariant;
    const maxQuantity = Number(input.max);
    const price = input.dataset.wholesalePrice;

    // Find or create item
    let currentItem = items.find((item) => item.id === variantId);

    if (!currentItem) {
      currentItem = { id: variantId, quantity: 0, price };
      items.push(currentItem);
    }
    // Calculate new quantity
    const quantityChange = qtyAdjust === "plus" ? 5 : -5;
    const proposedQuantity = currentItem.quantity + quantityChange;

    console.log({ proposedQuantity, maxQuantity, quantityChange });
    // Validate and apply quantity change
    if (proposedQuantity <= 0) {
      // Remove item if quantity would be 0 or negative
      items = items.filter((item) => item.id !== variantId);
      input.value = 0;
    } else if (proposedQuantity <= maxQuantity) {
      // Update quantity if within bounds
      currentItem.quantity = proposedQuantity;
      input.value = proposedQuantity;
    }

    updateTotal();
    localStorage.setItem("wholesale-items", JSON.stringify(items));
    adjustStickyTab();
  }

  //
  //
  function adjustStickyTab() {
    if (items.length > 0) {
      stickyTab.classList.add("active");
    } else {
      stickyTab.classList.remove("active");
    }
  }

  //
  //
  function updateTotal() {
    // if there are no items, set the total to 0
    if (items.length === 0) {
      totalElement.textContent = formatMoney(0);
      return;
    }
    // if there are items, calculate the total
    runningTotal = items.reduce(
      (acc, item) => acc + item.price * item.quantity,
      0
    );
    // format the total
    totalElement.textContent = formatMoney(runningTotal);
  }

  //
  //
  // add to cart
  addToCart.addEventListener("click", function (event) {
    if (items.length === 0) return;
    const thisButton = event.currentTarget;
    // thisButton.classList.add(`button--spinner`);

    thisButton.disabled = true;
    // remove price from items array
    items = items.map((item) => {
      return {
        id: item.id,
        quantity: item.quantity,
      };
    });

    let formData = { items: items };
    //
    // add the items to the cart
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.status === 422) {
          //show the error to the user
          const errorMessage = document.querySelector("[data-wholesale-error]");
          errorMessage.textContent = "* " + result.message;
          errorMessage.classList.add("error");
        }

        // remove the spinner
        // thisButton.classList.remove(`button--spinner`);
        thisButton.disabled = false;

        // clear items and local storage
        items = [];
        localStorage.removeItem("wholesale-items");
        // refresh the page
        updateTotal();
        //
        //
        // refresh the cart
        window.refreshCart();
        // trigger cart drawer to open
        document.getElementById("site-cart-sidebar").show();

        // hide sticky tab
        stickyTab.classList.remove("active");
        populateQuantities();
      })
      .catch((err) => {
        console.log("there was an error attempting to add to cart", err);
      });
  });
});

//
//
//
//

const formatMoney = function (cents, format) {
  const moneyFormat = "£{{amount}}";
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || moneyFormat;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "£1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
